export default __webpack_public_path__ + "static/media/notification-icon.8da59f43.svg";